/* eslint-disable import/prefer-default-export */
/* eslint-disable no-restricted-globals */

import { Kjoretoy } from "interfaces/Kjoretoy";
import { find } from "lodash-es";

export const findVehicleInList = (vehicleId: string, list: Kjoretoy[]): Kjoretoy | undefined =>
  find(list, k => k.id === vehicleId);
